import { PencilSimple, Vault } from '@phosphor-icons/react';
import { Chip, ImmoButton, InnenKarte, KartenTitel, KpiReihe, KpiTile, LeerZustand } from '../../../../../components/immobilien/ui';
import { eur } from '../../../../../lib/immobilien/format';
import { deDatum } from '../../../../../lib/immobilien/objektDetail';
import { kautionInfo } from '../../../../../lib/immobilien/einheitDetail';
import { kontaktName } from '../../../../../lib/objekte/objektKontakte';
import { KAUTION_CHIP } from '../EinheitWidgets';
import { useEinheitSeite } from '../EinheitSeitenKontext';
import { DatenZeile, ibanText } from './teile';

const zahlOderNull = (v: unknown): number | null => { if (v == null || v === '') return null; const x = Number(String(v).replace(',', '.')); return Number.isFinite(x) ? x : null; };

/** „Kaution“: Felder des Mietverhältnisses (wie der bisherige Kautionsblock); Ändern im Mietverhältnis-Dialog. */
export function KautionBereich() {
  const s = useEinheitSeite();
  if (s.laufende.length === 0) return <LeerZustand icon={Vault} titel="Keine Kaution" text="Ohne laufendes Mietverhältnis gibt es keine Kaution." />;
  return (
    <>
      {s.laufende.map(m => {
        const k = kautionInfo(m);
        const chip = KAUTION_CHIP[k.status];
        const saldo = zahlOderNull(m.kaution_saldo);
        return (
          <div key={m.id} className="flex flex-col" style={{ gap: 14 }}>
            <KpiReihe>
              <KpiTile label="Kaution (Soll)" wert={k.soll > 0 ? eur(k.soll) : '–'} sub={m.kaution_art || 'Art nicht erfasst'} icon={Vault} ton="acc" />
              <KpiTile label="Eingegangen" wert={eur(k.ist)} sub={<Chip groesse="xs" ton={chip.ton}>{chip.text}</Chip>} ton={k.status === 'hinterlegt' ? 'ok' : 'neutral'} wertFarbig={k.status === 'hinterlegt'} />
              <KpiTile label="Offen" wert={eur(k.offen)} sub={saldo !== null ? `Saldo ${eur(saldo)}` : 'kein Saldo erfasst'} ton={k.offen > 0 ? 'bad' : 'ok'} wertFarbig={k.offen > 0} />
            </KpiReihe>
            <InnenKarte>
              <KartenTitel rechts={s.laufende.length > 1 ? kontaktName(m) : undefined}>Details</KartenTitel>
              <div className="flex flex-col">
                <DatenZeile label="Art" wert={m.kaution_art ?? ''} />
                {m.kaution_gegenstand && <DatenZeile label="Gegenstand" wert={m.kaution_gegenstand} />}
                {m.kaution_raten != null && <DatenZeile label="Raten" wert={String(m.kaution_raten)} zahl />}
                {m.kaution_iban && <DatenZeile label="Kautionskonto" wert={ibanText(m.kaution_iban)} zahl />}
                {(m.kaution_gueltig_ab || m.kaution_gueltig_bis) && (
                  <DatenZeile label="Gültig" wert={`${deDatum(m.kaution_gueltig_ab)}${m.kaution_gueltig_bis ? ` bis ${deDatum(m.kaution_gueltig_bis)}` : ''}`} zahl />
                )}
              </div>
              <ImmoButton icon={PencilSimple} onClick={() => s.bearbeiteMietverhaeltnis(m, 'miete')} style={{ alignSelf: 'flex-start' }}>Im Mietverhältnis ändern</ImmoButton>
            </InnenKarte>
          </div>
        );
      })}
    </>
  );
}
